import {
  useQuery,
} from '@tanstack/react-query';
import { backendErrorsHandler } from '../../utils/Notification/BackendErrorsHandler';
import { IProduct } from '../../interfaces/Product';
import { getProductByIdV2 } from '../../services/products.service';
import { getOrderSequence } from '../../services/store.service';
const listQueryKey = 'products';

export const useGetProductById = (id: string, storeId: string) => useQuery<IProduct>({
  queryKey: [listQueryKey, { _id: id, storeId }],
  enabled: !!id && !!storeId,
  queryFn: async ({ queryKey }) => {
    try {
      const [_key, { _id: _id, storeId: selectedStoreId }] = queryKey;
      const res = await getProductByIdV2(_id, selectedStoreId);
      if (!res?.data?.data) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res.data.data;
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      backendErrorsHandler(e);
      throw e;
    }
  }
});

type GetOrderSequenceResponse = {
  currentSeq: number;
  nextSeq: number;
};

export const orderSequenceKeys = {
  root: ["orderSequence"] as const,
  byStore: (storeId: string) => [...orderSequenceKeys.root, storeId] as const,
};

export const useGetOrderSequence = (storeId: string) =>
  useQuery<GetOrderSequenceResponse>({
    queryKey: orderSequenceKeys.byStore(storeId),
    enabled: Boolean(storeId),
    queryFn: async () => {
      return await getOrderSequence(storeId);
    },
  });
